import { render, staticRenderFns } from "./schoolResourcesDetail.vue?vue&type=template&id=4c34e83e&scoped=true"
import script from "./schoolResourcesDetail.vue?vue&type=script&lang=js"
export * from "./schoolResourcesDetail.vue?vue&type=script&lang=js"
import style0 from "./schoolResourcesDetail.vue?vue&type=style&index=0&id=4c34e83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c34e83e",
  null
  
)

export default component.exports